// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-picker-cell {
  position: relative;
  width: 100%;
}

.due-date-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  width: 100%;
  text-align: left;
  transition: all 0.2s;
}

.due-date-button:hover {
  background: var(--color-gray-100);
  color: var(--color-primary);
}

.date-picker-popover {
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  z-index: 1000;
  min-width: 320px;
  margin-top: 4px;
}

.date-picker-header {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--surface-border);
}

.date-picker-presets {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.preset-btn {
  flex: 1 1;
  background: var(--color-gray-100);
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.preset-btn:hover {
  background: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
}

.date-picker-calendar {
  margin-bottom: 16px;
}

/* Custom calendar styling */
.custom-calendar {
  font-family: inherit;
  border: none;
}

.react-datepicker {
  font-family: inherit;
  border: none;
  background: var(--surface-card);
  color: var(--text-primary);
}

.react-datepicker__header {
  background: var(--color-gray-100);
  border-bottom: 1px solid var(--surface-border);
  padding-top: 8px;
}

.react-datepicker__current-month {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.react-datepicker__day-name {
  font-size: 12px;
  color: var(--text-secondary);
  width: 36px;
  line-height: 36px;
}

.react-datepicker__day {
  font-size: 13px;
  width: 36px;
  line-height: 36px;
  margin: 2px;
  border-radius: 6px;
  transition: all 0.2s;
}

.react-datepicker__day:hover {
  background: var(--color-primary);
  color: white;
}

.react-datepicker__day--selected {
  background: var(--color-primary);
  color: white;
}

.react-datepicker__day--selected:hover {
  background: var(--color-primary-dark);
}

.react-datepicker__day--keyboard-selected {
  background: var(--color-primary-light);
  color: white;
}

.react-datepicker__day--today {
  font-weight: 600;
  background: var(--color-gray-100);
}

.react-datepicker__navigation {
  top: 10px;
}

.react-datepicker__navigation-icon::before {
  border-color: var(--text-secondary);
}

.date-picker-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid var(--surface-border);
}

.btn-secondary {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  color: var(--text-secondary);
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: var(--color-gray-100);
  border-color: var(--color-gray-300);
}

.btn-primary {
  background: var(--color-primary);
  border: none;
  color: white;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: var(--color-primary-dark);
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .date-picker-popover {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DatePickerCell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;EACjB;AACF","sourcesContent":[".date-picker-cell {\n  position: relative;\n  width: 100%;\n}\n\n.due-date-button {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  width: 100%;\n  text-align: left;\n  transition: all 0.2s;\n}\n\n.due-date-button:hover {\n  background: var(--color-gray-100);\n  color: var(--color-primary);\n}\n\n.date-picker-popover {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: var(--surface-card);\n  border: 1px solid var(--surface-border);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 16px;\n  z-index: 1000;\n  min-width: 320px;\n  margin-top: 4px;\n}\n\n.date-picker-header {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--surface-border);\n}\n\n.date-picker-presets {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.preset-btn {\n  flex: 1;\n  background: var(--color-gray-100);\n  border: 1px solid var(--surface-border);\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.preset-btn:hover {\n  background: var(--color-primary);\n  color: white;\n  border-color: var(--color-primary);\n}\n\n.date-picker-calendar {\n  margin-bottom: 16px;\n}\n\n/* Custom calendar styling */\n.custom-calendar {\n  font-family: inherit;\n  border: none;\n}\n\n.react-datepicker {\n  font-family: inherit;\n  border: none;\n  background: var(--surface-card);\n  color: var(--text-primary);\n}\n\n.react-datepicker__header {\n  background: var(--color-gray-100);\n  border-bottom: 1px solid var(--surface-border);\n  padding-top: 8px;\n}\n\n.react-datepicker__current-month {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.react-datepicker__day-name {\n  font-size: 12px;\n  color: var(--text-secondary);\n  width: 36px;\n  line-height: 36px;\n}\n\n.react-datepicker__day {\n  font-size: 13px;\n  width: 36px;\n  line-height: 36px;\n  margin: 2px;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.react-datepicker__day:hover {\n  background: var(--color-primary);\n  color: white;\n}\n\n.react-datepicker__day--selected {\n  background: var(--color-primary);\n  color: white;\n}\n\n.react-datepicker__day--selected:hover {\n  background: var(--color-primary-dark);\n}\n\n.react-datepicker__day--keyboard-selected {\n  background: var(--color-primary-light);\n  color: white;\n}\n\n.react-datepicker__day--today {\n  font-weight: 600;\n  background: var(--color-gray-100);\n}\n\n.react-datepicker__navigation {\n  top: 10px;\n}\n\n.react-datepicker__navigation-icon::before {\n  border-color: var(--text-secondary);\n}\n\n.date-picker-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 12px;\n  border-top: 1px solid var(--surface-border);\n}\n\n.btn-secondary {\n  background: var(--surface-card);\n  border: 1px solid var(--surface-border);\n  color: var(--text-secondary);\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: var(--color-gray-100);\n  border-color: var(--color-gray-300);\n}\n\n.btn-primary {\n  background: var(--color-primary);\n  border: none;\n  color: white;\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary:hover {\n  background: var(--color-primary-dark);\n}\n\n.btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .date-picker-popover {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 90vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
